import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table type-default font-md" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "disp-option-list component-box box-default mt8" }
const _hoisted_4 = { class: "form-group group-scope" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group checkboxes" }
const _hoisted_7 = { class: "custom-control custom-checkbox" }
const _hoisted_8 = { class: "data-layer-list component-box box-default mt8" }
const _hoisted_9 = { class: "box-contents" }
const _hoisted_10 = {
  key: 0,
  class: "form-group",
  style: {'margin-bottom': '0.6rem'}
}
const _hoisted_11 = { class: "custom-control custom-checkbox" }
const _hoisted_12 = ["onUpdate:modelValue", "disabled", "onChange", "id"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "component-box box-route-search mt8" }
const _hoisted_15 = { class: "box-contents" }

import RouteSearch from 'src/components/Top/RouteSearch.vue';
import geoItemSearchComponents from 'src/components/Top/geoItemSearchComponents';
import { useTopShellStore } from 'src/composables/useTopView';
import { useGeoItemLayersStore } from 'src/composables/useGeoItemLayers';
import { useMovieSearchStore } from 'src/composables/useMovieSearch';


export default /*@__PURE__*/_defineComponent({
  ...{
  components: {
    RouteSearch,
    ...geoItemSearchComponents,
  },
},
  __name: 'TopLeftPane',
  setup(__props) {

const {
  state,
  styles,
  masters,
  geoItemsMeta,
  carState,
  groupScopeMap,
  updateShowCarIcons,
  onCarListRowClick,
  onCarSearchParamsChange,
  dtFormat,
} = useTopShellStore();

const {
  isMaxVisibleGeoItemLayersReached,
  changeGeoItemLayers,
  refreshGeoItemLayers,
  geoItemSearchRef,
} = useGeoItemLayersStore();

const { isValidRouteMovieSearchDateParams, doRouteMovieSearch } = useMovieSearchStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "car-list table-container",
      style: _normalizeStyle({
      'min-height': _unref(styles).carListStyles.minHeight,
      'max-height': _unref(styles).carListStyles.maxHeight,
    })
    }, [
      _createElementVNode("table", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "車両"),
            _createElementVNode("th", null, "状態"),
            _createElementVNode("th", null, "車種"),
            _createElementVNode("th", null, "更新時刻")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carState).cars, (car) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: car.deviceId,
              onClick: ($event: any) => (_unref(onCarListRowClick)(car)),
              class: _normalizeClass(["table-row", {'selected': car.isSelected}])
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(car.device.carName), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(car.statusDisp), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(car.device.carKindDisp), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(_unref(dtFormat)(car.ts)), 1)
              ])
            ], 10, _hoisted_2))
          }), 128))
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "box-header-bar" }, " 表示切替 ", -1)),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-control-label mr2 mb0" }, "表示車両:", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(carState).carSearchParams.groupScopeId) = $event)),
          class: "custom-select",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onCarSearchParamsChange) && _unref(onCarSearchParamsChange)(...args)))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("option", { value: null }, "全て", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupScopeMap), (value, name) => {
            return (_openBlock(), _createElementBlock("option", {
              key: name,
              value: name
            }, _toDisplayString(value.label), 9, _hoisted_5))
          }), 128))
        ], 544), [
          [_vModelSelect, _unref(carState).carSearchParams.groupScopeId]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "custom-control-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(carState).showCarIcons) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(updateShowCarIcons) && _unref(updateShowCarIcons)(...args))),
            id: "disp-option-list-show-car-icons"
          }, null, 544), [
            [_vModelCheckbox, _unref(carState).showCarIcons]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            class: "custom-control-label",
            for: "disp-option-list-show-car-icons"
          }, " 車両アイコン ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "box-header-bar" }, " レイヤーデータ表示 ", -1)),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(geoItemsMeta).list, (e, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
            (!e.hideToggleCheckbox)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      "onUpdate:modelValue": ($event: any) => ((_unref(geoItemsMeta).show[e.name]) = $event),
                      disabled: !_unref(geoItemsMeta).show[e.name] && _unref(isMaxVisibleGeoItemLayersReached),
                      onChange: ($event: any) => (_unref(changeGeoItemLayers)(e.name)),
                      id: `geo-items-layer-switch-${e.name}`
                    }, null, 40, _hoisted_12), [
                      [_vModelCheckbox, _unref(geoItemsMeta).show[e.name]]
                    ]),
                    _createElementVNode("label", {
                      class: "custom-control-label",
                      for: `geo-items-layer-switch-${e.name}`
                    }, _toDisplayString(e.dispName) + " " + _toDisplayString(_unref(geoItemsMeta).countsDisp[e.name]), 9, _hoisted_13)
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent('geo-item-search-' + e.name), {
                    ref_for: true,
                    ref: _unref(geoItemSearchRef)(e.name),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(refreshGeoItemLayers)({ spinnerMsg: _unref(state).ui.waitSpinner.msgDefault })))
                  }, null, 544)), [
                    [_vShow, _unref(geoItemsMeta).show[e.name]]
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "box-header-bar" }, " ルート検索 ", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(RouteSearch, {
          "road-name-disps": _unref(masters).kp.roadNameDisps,
          "is-valid-date-params": _unref(isValidRouteMovieSearchDateParams),
          onRouteSearch: _unref(doRouteMovieSearch)
        }, null, 8, ["road-name-disps", "is-valid-date-params", "onRouteSearch"])
      ])
    ])
  ], 64))
}
}

})